export default "__VITE_ASSET__BT_psPUY__"